import React from "react";
import { Reveal, Overline } from "@/components/Reveal";
import { useLang } from "@/context/LanguageContext";
import { IMAGES } from "@/data/content";

export const Gallery = () => {
  const { t } = useLang();
  return (
    <section id="gallery" data-testid="gallery-section" className="py-24 md:py-32 lg:py-40 bg-[#FAF9F6]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-3xl mb-14 lg:mb-20">
          <Reveal><Overline className="mb-6">{t.gallery.overline}</Overline></Reveal>
          <Reveal delay={0.1}>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight leading-[1.05] text-[#1A1A1A]">
              {t.gallery.title}
            </h2>
          </Reveal>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 auto-rows-[220px] md:auto-rows-[300px]">
          {IMAGES.gallery.map((img, i) => (
            <Reveal
              key={img.url}
              delay={(i % 3) * 0.1}
              className={`overflow-hidden ${img.span === "wide" ? "col-span-2 lg:col-span-2" : "col-span-1"} ${i === 0 ? "row-span-1" : ""}`}
            >
              <div data-testid={`gallery-item-${i}`} className="group relative w-full h-full overflow-hidden bg-[#EBE5D9]">
                <img
                  src={img.url}
                  alt={img.alt}
                  loading="lazy"
                  decoding="async"
                  width={img.w}
                  height={img.h}
                  className="w-full h-full object-cover transition-transform duration-[1.1s] ease-out group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-[#1A1A1A]/0 group-hover:bg-[#1A1A1A]/15 transition-colors duration-500" />
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
